// modale de recherche dans le Header.php
// active/desactive le submit si input remplie/pas rempli


window.onload = () => {
    let inputText = document.querySelector('.searchform__input-text')
    let button = document.querySelector('.searchform__input-button')

    inputText.addEventListener('keyup', function (e) {
        submitSearch(inputText, button)
    });

    let submitSearch = (keywords, button) => {

        if (keywords.value.length === 0) {
            button.setAttribute('disabled', '')
        } else {
            button.removeAttribute('disabled')
        }
    }
}